<aayn-modal-for-payments
  icon="rocket-2"
  title="Upgrade Successful"
  description="Congratulations, you have just upgraded your ADYOUNEED plan. Click on the button below to enjoy your new plan."
  [dismissFn]="dismissModals"
>
  <button ayn-button="primary" icon="circle-chevron-right" (click)="dismissModals()">Continue</button>
</aayn-modal-for-payments>
